import React from "react";
import PropTypes from "prop-types";

/**
 * InputField
 * - Exposes both default export and named `Input` export so callers can import either.
 */
const InputField = ({
  id,
  name,
  type = "text",
  label,
  placeholder = "",
  required = false,
  className = "",
  value,
  onChange,
  autoComplete,
  ...rest
}) => {
  const inputId = id || name || `input_${Math.random().toString(36).slice(2, 9)}`;

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <input
        id={inputId}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete}
        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
        {...rest}
      />
    </div>
  );
};

InputField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  autoComplete: PropTypes.string,
};

InputField.defaultProps = {
  type: "text",
  placeholder: "",
  required: false,
  className: "",
  onChange: () => {},
  autoComplete: "off",
};

// Provide both named `Input` and default export
export const Input = InputField;
export { InputField };
export default InputField;
